// Spaces that the rich text editor can leave behind without showing anything.
const INVISIBLE_SPACES = /[\s\u200b-\u200d\u2060\ufeff]+/g;

// A parsed document is inert: nothing in the value runs or loads.
const parseRichText = (html: string) => new DOMParser().parseFromString(html, "text/html").body;

// The visible text of a rich text (HTML) value on one line: the tags are dropped and line breaks, paragraphs and list
// items become spaces.
export const getRichTextPlainText = (html?: string | null): string => {
	if (!html) {
		return "";
	}

	const body = parseRichText(html);
	body.querySelectorAll("br, p, div, li").forEach(element => element.after(" "));

	return (body.textContent ?? "").replace(INVISIBLE_SPACES, " ").trim();
};

// The HTML as the browser writes it back (or "" when nothing is visible), so a value loaded from the server and the
// editor's copy of it compare equal.
export const toComparableRichText = (html: string): string => {
	const serialized = parseRichText(html.trim()).innerHTML;
	return getRichTextPlainText(serialized) ? serialized : "";
};
